module.exports = __webpack_public_path__ + "static/media/plus.ab54c8e9.svg";